"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactBootstrap = require("react-bootstrap");

var _reactScrollmagic = require("react-scrollmagic");

var _react = _interopRequireDefault(require("react"));

var _HeadlineModule = _interopRequireDefault(require("./Headline.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Headline = props => {
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "m-0 m-sm-2 " + props.className
  }, /*#__PURE__*/_react.default.createElement(_reactScrollmagic.Scene, {
    classToggle: _HeadlineModule.default.visible,
    triggerHook: 0.9,
    reverse: false
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: _HeadlineModule.default.headline + " sectionTitles text-center p-0"
  }, props.text)));
};

var _default = Headline;
exports.default = _default;